import React  from 'react'
import Grid from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress'

function Loading(props){
	return(
		<Grid 
			container 
			item 
			justifyContent="center" 
			alignItems="center" 
			height="100vh"
		>
			<CircularProgress size={60} style={{color:"#3c177d"}}/>
		</Grid>
	)
}

export default Loading
